import gql from "graphql-tag"

export const LIST_CONVERSATIONS = gql`
    query ConversationsList($nextToken: MongoID) {
        conversationsList(nextToken: $nextToken) {
            _id
            _metadata {
                updatedAt
                updatedBy {
                    _id
                    name
                }
            }
            latestMessage
            title
            tools {
                toolId
            }
            users
        }
    }
`
